import React, { useState } from 'react';
import { Flex, Text, VStack, Pressable, Box } from 'native-base';
import NewTopicBox from './NewTopicBox';
import EditBox from './EditBox';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faReply, faPencil } from '@fortawesome/pro-solid-svg-icons';
import { LANGUAGES } from '../../../Constants';
import PressableInput from './PressableInput';
import { useEditPostDispatch } from '../../../../context/edit';
import { useReplyDispatch } from '../../../../context/reply';
const TopicReplyForm = ({
  topic,
  reply,
  type,
  handlePost,
  newTopicButton,
  editButton,
  isTypeTopic,
  startNewTopicButtonRef,
  onCloseHandler
}) => {
  const [showNewTopicModal, setShowNewTopicModal] = useState(false);
  const [showEditPostModal, setShowEditPostModal] = useState(false);
  const handleShowTopicModal = () => {
    setShowNewTopicModal(true);
  };
  const dispatch = useEditPostDispatch();
  const replyDispatch = useReplyDispatch();
  const handleEditClick = () => {
    topic ? setShowEditPostModal(true) : dispatch({
      type: 'SHOW_EDIT_POST_MODAL',
      payload: reply.id
    });
  };
  const handleReplyClick = () => {
    topic ? replyDispatch({
      type: 'SHOW_REPLY_MODAL',
      payload: topic.id
    }) : replyDispatch({
      type: 'SHOW_REPLY_MODAL',
      payload: reply.id
    });
  };
  const handleButton = () => {
    if (newTopicButton) {
      // creating a new topic; only one button is eligible for this
      return /*#__PURE__*/React.createElement(PressableInput, {
        handlePress: handleShowTopicModal,
        pressableRef: startNewTopicButtonRef,
        placeholder: LANGUAGES.PLACEHOLDERS.NEW_TOPIC
      });
    } else {
      if (editButton) {
        // editing a topic/reply
        return /*#__PURE__*/React.createElement(Pressable, {
          accessibilityLabel: 'Edit topic/reply',
          onPress: handleEditClick
        }, /*#__PURE__*/React.createElement(Flex, {
          direction: 'row',
          alignItems: 'center'
        }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faPencil
        }), " ", /*#__PURE__*/React.createElement(Text, null, "Edit")));
      }
    }

    // return a button for creating a reply by default
    return /*#__PURE__*/React.createElement(Pressable, {
      accessibilityLabel: 'Write a reply',
      onPress: handleReplyClick
    }, /*#__PURE__*/React.createElement(Flex, {
      direction: 'row',
      alignItems: 'center'
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faReply
    }), " ", /*#__PURE__*/React.createElement(Text, null, "Reply")));
  };

  // const menuWidth = Platform.OS === 'web' ? null : deviceWidth;
  const handlePostButton = handleButton();
  return /*#__PURE__*/React.createElement(Box, null, showNewTopicModal && /*#__PURE__*/React.createElement(NewTopicBox, {
    showNewTopicModal: showNewTopicModal,
    setShowNewTopicModal: setShowNewTopicModal,
    handlePost: handlePost,
    onCloseHandler: onCloseHandler
  }), showEditPostModal && /*#__PURE__*/React.createElement(EditBox, {
    topic: topic,
    reply: reply,
    isTypeTopic: isTypeTopic,
    type: type,
    showEditPostModal: showEditPostModal,
    setShowEditPostModal: setShowEditPostModal,
    handlePost: handlePost,
    onCloseHandler: onCloseHandler
  }), /*#__PURE__*/React.createElement(VStack, null, handlePostButton));
};
export default TopicReplyForm;
//# sourceMappingURL=TopicReplyForm.js.map